// extracted by mini-css-extract-plugin
export default {"block":"todo-list_block__NxrId","todo":"todo-list_todo__ThPoG","inputfield":"todo-list_inputfield__C9GfU","input":"todo-list_input__ul4AD","add":"todo-list_add__TmXwb"};